<template>
  <el-card>
    <div slot="header" class="font-weight-bold text-left">
      {{ $t('pages.cart') }}
    </div>
    <el-card v-if="products && products.length > 0" class="text-left">
      <div slot="header" class="font-weight-bold text-left">
        {{ $tc('products.product', 2) }}
      </div>
      <ProductCartEntry
        v-for="product in products"
        :key="product.id"
        class="mb-1 py-2 border-bottom"
        :product="product"
        read-only
      />
    </el-card>

    <el-card v-if="systems && systems.length > 0" class="mt-3 text-left">
      <div slot="header" class="font-weight-bold text-left">
        {{ $tc('systems.system', 2) }}
      </div>
      <SystemCartEntry
        v-for="system in systems"
        :key="system.id"
        class="mb-1 py-2 border-bottom"
        :system="system"
        read-only
      />
    </el-card>
  </el-card>
</template>

<script>
import ProductCartEntry from '../../../cart/components/ProductCartEntry';
import SystemCartEntry from '../../../cart/components/SystemCartEntry';
export default {
  name: 'OrderCartCard',
  components: { SystemCartEntry, ProductCartEntry },
  props: {
    systems: {
      type: Array,
      default: () => [],
    },
    products: {
      type: Array,
      default: () => [],
    },
  },
  mounted() {},
  destroyed() {},
  data() {
    return {};
  },
  computed: {},
  methods: {},
};
</script>

<style scoped></style>
